import { openDB } from "idb";
import type { CharacterDraft } from "../domain/types";

const DATABASE = "fallout2d20";
const STORE = "state";
const DRAFT_KEY = "character-draft-v2";
const LEGACY_KEY = "fallout2d20:character-draft";

const dbPromise = openDB(DATABASE, 1, {
  upgrade(database) {
    database.createObjectStore(STORE);
  },
});

export async function loadDraft(): Promise<CharacterDraft | null> {
  const db = await dbPromise;
  return (await db.get(STORE, DRAFT_KEY)) ?? migrateLegacyDraft(db);
}

export async function saveDraft(draft: CharacterDraft): Promise<void> {
  const db = await dbPromise;
  await db.put(STORE, structuredClone(draft), DRAFT_KEY);
}

export async function clearDraft(): Promise<void> {
  const db = await dbPromise;
  await db.delete(STORE, DRAFT_KEY);
}

async function migrateLegacyDraft(
  db: Awaited<typeof dbPromise>,
): Promise<CharacterDraft | null> {
  let raw: string | null = null;
  try {
    raw = window.localStorage.getItem(LEGACY_KEY);
  } catch {
    return null;
  }
  if (!raw) return null;

  try {
    const envelope = JSON.parse(raw) as {
      draft?: CharacterDraft;
      schemaVersion?: number;
    };
    if (envelope.schemaVersion !== 1 || !envelope.draft) return null;
    await db.put(STORE, envelope.draft, DRAFT_KEY);
    window.localStorage.removeItem(LEGACY_KEY);
    return envelope.draft;
  } catch {
    return null;
  }
}
